import { useSteps } from '~/hooks';
import { ProgressWrapper, Step, StepContainer, StepLabel } from './styles';

export const ProgressSteps = () => {
    const { currentStep, totalSteps } = useSteps();

    return (
        <ProgressWrapper>
            <StepContainer>
                {Array.from({ length: totalSteps }, (_, i) => (
                    <Step key={i} isCompleted={i + 1 < currentStep} isActive={i + 1 === currentStep} />
                ))}
            </StepContainer>
            <StepLabel>{`Step ${currentStep} of ${totalSteps}`}</StepLabel>
        </ProgressWrapper>
    );
};
